import {
  getDashboardDocDealsService,
  fetchDashboardSoldProductsService,
  fetchDashboardAccountsService,
  fetchDashboardLeaderboardService,
  fetchDashboardDealValuesService,
  fetchDashboardHighValueDealsService,
} from "./dashboardServices";

import {
  dashboardPipelineDoc,
  dashboardDocTypes,
  filterObjFromArray,
  dashboardDocTypesByStatus,
} from "./dashboardMethods";

export const getDashboardDocDeals = (userID, fromDate, toDate) => dispatch =>
  new Promise((resolve, reject) => {
    getDashboardDocDealsService(userID, fromDate, toDate)
      .then(response => {
        const payload = {
          dealFrequencies: response.DealFrequencies,
          pipelineDocs: dashboardPipelineDoc(
            response.DocFrequencies,
            response.DealFrequencies,
            dashboardDocTypesByStatus(response.DocTypes),
          ),
          documentTyes: dashboardDocTypes(response.DocTypes),
        };

        dispatch({
          type: "DASHBOARD_DOC_DEALS",
          payload,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`dashboardActions => getDashboardDocDeals => ${error}`);
        reject(error);
      });
  });

export const getDashboardDealValues = (userID, fromDate, toDate) => dispatch =>
  new Promise((resolve, reject) => {
    fetchDashboardDealValuesService(userID, fromDate, toDate)
      .then(response => {
        const wonDeals = filterObjFromArray(
          response.WonLostDealData,
          "name",
          "DOCUMENT_CLIENT_APPROVED",
        )[0];
        const lostDeals = filterObjFromArray(
          response.WonLostDealData,
          "name",
          "DOCUMENT_CLIENT_REJECTED",
        )[0];
        const payload = {
          response,
          wonDeals: wonDeals || null,
          lostDeals: lostDeals || null,
          DealValuesByMonths: response.DealValuesByMonths.reverse(),
        };
        dispatch({
          type: "DASHBOARD_DEAL_VALUES",
          payload,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`dashboardActions => getDashboardDealValues => ${error}`);
        reject(error);
      });
  });

export const getDashboardSoldProducts = (
  userID,
  fromDate,
  toDate,
) => dispatch =>
  new Promise((resolve, reject) => {
    fetchDashboardSoldProductsService(userID, fromDate, toDate)
      .then(response => {
        dispatch({
          type: "DASHBOARD_SOLD_PRODUCTS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(
          `dashboardActions => getDashboardSoldProducts => ${error}`,
        );
        reject(error);
      });
  });

export const getDashboardAccounts = (userID, fromDate, toDate) => dispatch =>
  new Promise((resolve, reject) => {
    fetchDashboardAccountsService(userID, fromDate, toDate)
      .then(response => {
        dispatch({
          type: "DASHBOARD_ACCOUNTS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`dashboardActions => getDashboardAccounts => ${error}`);
        reject(error);
      });
  });

export const getDashboardLeaderboard = (fromDate, toDate) => dispatch =>
  new Promise((resolve, reject) => {
    fetchDashboardLeaderboardService(fromDate, toDate)
      .then(response => {
        dispatch({
          type: "DASHBOARD_LEADERBOARD",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(
          `dashboardActions => getDashboardLeaderboard => ${error}`,
        );
        reject(error);
      });
  });

export const getDashboardHighValueDeals = (
  userID,
  fromDate,
  toDate,
) => dispatch =>
  new Promise((resolve, reject) => {
    fetchDashboardHighValueDealsService(userID, fromDate, toDate)
      .then(response => {
        dispatch({
          type: "DASHBOARD_HIGH_VALUE_DEALS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(
          `dashboardActions => getDashboardHighValueDeals => ${error}`,
        );
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/DashboardActions/dashboardActions.js